'use client'

import React, { useEffect, useState } from 'react'

const SCALES = ['1', '1.15', '1.3'] as const
const LABELS = ['Dimensione normale', 'Dimensione grande', 'Dimensione molto grande']
const STORAGE_KEY = 'vernicisubito-site-scale'

type Scale = (typeof SCALES)[number]

const isScale = (value: unknown): value is Scale => SCALES.includes(value as Scale)

/** The prototype's "A A A" text-size switch: zooms the whole page and remembers the choice. */
export const SiteZoom: React.FC = () => {
  const [scale, setScale] = useState<Scale>('1')

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY)
      if (isScale(stored)) setScale(stored)
    } catch {
      // Storage can be unavailable (private mode): keep the default size.
    }
  }, [])

  useEffect(() => {
    document.documentElement.style.zoom = scale
    try {
      window.localStorage.setItem(STORAGE_KEY, scale)
    } catch {}
  }, [scale])

  return (
    <div aria-label="Dimensione del sito" className="sitezoom" role="group">
      {SCALES.map((value, i) => (
        <button
          aria-label={LABELS[i]}
          aria-pressed={scale === value}
          key={value}
          onClick={() => setScale(value)}
          type="button"
        >
          A
        </button>
      ))}
    </div>
  )
}
